// extracted by mini-css-extract-plugin
module.exports = {"MenuIcon":"menuicon_MenuIcon__1XEzp"};